import Controller from "csi/action/Controller";
import JsonResponse from "csi/comm/JsonResponse";
import PostRequest from "csi/comm/PostRequest";
import html from "csi/html";
import declare from "dojo/_base/declare";
import { startsWith } from "lodash";

const DGaaSDownloadController = declare(Controller, {
	/**
	 * @override
	 * Set the parameters to the call method DGaaS DownloadTemplate
	 */
	process() {
		const cache = this.getCache();
		const dGaaSOwner = cache.getNode(this.m_urlNode);
		let dGaaSTemplateRevisionUrl = "";
		if (dGaaSOwner.$Type === "DGaaSTemplateRevision") {
			dGaaSTemplateRevisionUrl = dGaaSOwner.$URL;
		} else {
			// DGaaS table view - Retrieve the latest revision's for the download
			const dGaaSTemplateRevision = cache.getNode(dGaaSOwner.LatestRevision);
			dGaaSTemplateRevisionUrl = dGaaSTemplateRevision.$URL;
		}
		const request = new PostRequest("DocumentGenerator", "DownloadTemplate");
		request.addParameter("DGaaSTemplateRevision", dGaaSTemplateRevisionUrl);

		const args = { handleAs: "blob" };
		const dfd = request.post(args).then(async (response) => {
			const contentType = response.getHeader("Content-Type");
			if (startsWith(contentType, "application/json")) {
				// the document cannot be JSON. We presume it is some kind of error
				const json = JSON.parse(await response.data.text());
				const jsonResponse = new JsonResponse(json);
				throw jsonResponse.getError();
			} else {
				const contentDisposition = response.getHeader("Content-Disposition");
				const filename = contentDisposition ? decodeURIComponent((contentDisposition.match(/filename="([^"]+)"/)?.[1]) || "") : "";
				html.download(filename, response.data);
			}
		});
		this.waitForPublish(dfd, true);
	},
});
export = DGaaSDownloadController;